let ol = require('openlayers');

class AbstractOverlay {
    constructor(params) {
        this.initStore(params);
    }

    initStore(params) {
        this.store = {};
        this.params = params;
    }
}

module.exports = AbstractOverlay;